import { Injectable } from "@angular/core";
import { AppContext } from "../../contexts/app-context";

@Injectable({ providedIn: "root" })
export class UserRoleMediator {
  constructor(private appContext: AppContext) {}

  public getCompanyFiscalNumberRoot(): Array<string> {
    let user = this.appContext.getUser();
    let userFiscalNumber = [];
    if (!user.isAdministrator() && !user.isManager()) {
      userFiscalNumber = user.getCompanyFiscalNumber();
    }
    return userFiscalNumber;
  }
}
